import { render, staticRenderFns } from "./storelist3.vue?vue&type=template&id=2f952812&scoped=true&"
import script from "./storelist3.vue?vue&type=script&lang=js&"
export * from "./storelist3.vue?vue&type=script&lang=js&"
import style0 from "./storelist3.vue?vue&type=style&index=0&id=2f952812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f952812",
  null
  
)

export default component.exports